import { DataFormField } from "types/models/input-field-type";

export const durationValue = [
  { value: "select", label: "Chọn" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
];

export const durationType = [
  { value: "select", label: "Chọn" },
  { value: "year", label: "Năm" },
  { value: "month", label: "Tháng" },
  { value: "week", label: "Tuần" },
  { value: "day", label: "Ngày" },
];

export const conditionFrame = [
  { value: "select", label: "Chọn" },
  { value: "good", label: "Tốt" },
  { value: "bad", label: "Kém" },
  { value: "scratched", label: "Xước" },
];

export const lensCondition = [
  { value: "select", label: "Chọn" },
  { value: "good", label: "Tốt" },
  { value: "bad", label: "Kém" },
  { value: "scratched", label: "Xước" },
];

export const lensTypeName = [
  {
    label: "Chọn",
    value: "select",
  },
  {
    label: "Đơn tròng - Nhìn xa",
    value: "singleDistance",
  },
  {
    label: "Đơn tròng - Nhìn gần",
    value: "singleNear",
  },
  {
    label: "Hai tròng",
    value: "bifocal",
  },
  {
    label: "Đa tròng",
    value: "progressive",
  },
  {
    label: "Hai tròng - D",
    value: "dBifocal",
  },
  {
    label: "Hai tròng - KT",
    value: "ktBifocal",
  },
];

export const frameMaterial = [
  {
    label: "Chọn",
    value: "select",
  },
  {
    label: "Lựa chọn của bệnh nhân",
    value: "patientChoice",
  },
  {
    label: "Shell",
    value: "shell",
  },
  {
    label: "Kim loại",
    value: "metal",
  },
  {
    label: "Titan",
    value: "titanium",
  },
  {
    label: "Shell(Paediatric Use)",
    value: "shellUse",
  },
  {
    label: "Hypo-Allergic Metal",
    value: "hypoMetal",
  },
  {
    label: "Nhựa",
    value: "plastic",
  },
  {
    label: "Carbon",
    value: "carbon",
  },
  {
    label: "Acetate",
    value: "acetate",
  },
  {
    label: "Aliminium",
    value: "aliminium",
  },
  {
    label: "Optyl",
    value: "optyl",
  },
  {
    label: "Polyamide",
    value: "polyamide",
  },
  {
    label: "Optyl",
    value: "optyl",
  },
  {
    label: "Stainless Stell",
    value: "stainlessStell",
  },
  {
    label: "TR-90",
    value: "tr",
  },
  {
    label: "Ultem",
    value: "ultem",
  },
];

export const lensMaterial = [
  {
    label: "Chọn",
    value: "select",
  },
  {
    label: "Mineral",
    value: "mineral",
  },
  {
    label: "CR39r",
    value: "cR39r",
  },
  {
    label: "Patient Choice",
    value: "patientChoice",
  },
  {
    label: "Polycarbonate",
    value: "polycarbonate",
  },
  {
    label: "Trivex",
    value: "trivex",
  },
  {
    label: "Organic",
    value: "organic",
  },
  {
    label: "Evalution",
    value: "evalution",
  },
  {
    label: "MR7",
    value: "mr7",
  },
  {
    label: "MR10",
    value: "mr10",
  },
  {
    label: "MR8",
    value: "mr8",
  },
  {
    label: "Press On",
    value: "pressOn",
  },
];

const css = {
  xs: 24,
  md: 24,
  lg: 12,
  xl: 12,
};

const duration = [
  {
    type: "SELECT",
    label: "Thời gian sử dụng",
    options: durationValue,
    css: css,
    name: ["spectaclesConditionDto", "durationValue"],
  },
  {
    type: "SELECT",
    label: "",
    options: durationType,
    css: css,
    name: ["spectaclesConditionDto", "durationType"],
  },
];

const data: DataFormField[] = [
  {
    type: "SELECT",
    label: "Tình trạng gọng kính",
    options: conditionFrame,
    css: css,
    name: ["spectaclesConditionDto", "conditionFrame"],
    placeholder: "",
  },
  {
    type: "SELECT",
    label: "Loại mắt kính",
    options: lensTypeName,
    css: css,
    name: ["spectaclesConditionDto", "lensTypeName"],
    placeholder: "",
  },
  {
    type: "INPUT",
    label: "Khoảng cách đồng tử",
    suffix: "mm",
    css: css,
    name: ["spectaclesConditionDto", "dboc"],
    placeholder: "",
  },
  {
    type: "SELECT",
    label: "Tình trạng mắt kính",
    options: lensCondition,
    css: css,
    name: ["spectaclesConditionDto", "lensCondition"],
    placeholder: "",
  },
  {
    type: "SELECT",
    label: "Chất liệu gọng kính",
    options: frameMaterial,
    css: css,
    name: ["spectaclesConditionDto", "frameMaterial"],
    placeholder: "",
  },
  {
    type: "SELECT",
    label: "Chất liệu mắt kính",
    options: lensMaterial,
    css: css,
    name: ["spectaclesConditionDto", "lensMaterial"],
    placeholder: "",
  },
];

export { data, duration };
